import { Capacitor } from '@capacitor/core';

export type NativeAnalyticsConsentStatus = 'pending' | 'granted' | 'denied';
type NativeAnalyticsImplementation = typeof import('./nativeFirebaseAnalyticsImpl');
let implementation: Promise<NativeAnalyticsImplementation> | undefined;

function invokeNative(action: (module: NativeAnalyticsImplementation) => Promise<boolean>): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return Promise.resolve(false);
  // Every caller registers on the same promise immediately, retaining call
  // order while the implementation loads. A failed load stays fail-closed.
  implementation ??= import('./nativeFirebaseAnalyticsImpl');
  return implementation.then(action).catch(() => false);
}

export async function syncNativeFirebaseAnalyticsConsent(
  status: NativeAnalyticsConsentStatus
): Promise<boolean> {
  return invokeNative(module => module.syncNativeFirebaseAnalyticsConsent(status));
}

export async function setNativeFirebaseAnalyticsUserId(userId: string | null): Promise<boolean> {
  return invokeNative(module => module.setNativeFirebaseAnalyticsUserId(userId));
}

export async function trackNativeFirebaseAnalyticsEvent(
  eventName: string,
  params?: Record<string, unknown>,
  eventId?: string,
  mayDeliver?: () => boolean
): Promise<boolean> {
  return invokeNative(module => module.trackNativeFirebaseAnalyticsEvent(eventName, params, eventId, mayDeliver));
}
